<template>
  <div class="input">
    <label class="input__label" :for="type" />
    <input
      class="input__input"
      :name="type"
      :id="type"
      :placeholder="placeholder"
      v-model="inputValue"
      :autocomplete="type === 'password' && 'new-password'"
      :type="type === 'password--repeat'?'password':type "
      @input="$emit('input', inputValue)"
    />
    <div
      class="input__icon"
      :style="{'backgroundImage': `${
        type==='email'? 'url(' + mailIcon + ')' :
        type==='login'? 'url(' + loginIcon + ')':
        type==='password' || type==='password--repeat'? 'url('+ passIcon + ')':
        null}`}"
    />
  </div>
</template>

<script>
import mailIcon from "@/assets/mail__icon.png";
import loginIcon from "@/assets/login__icon.png";
import passIcon from "@/assets/password__icon.png";

export default {
  name: "select-buttom",
  props: ["placeholder", "action", "type", "value"],
  components: {},
  data() {
    return {
      mailIcon:mailIcon,
      loginIcon:loginIcon,
      passIcon:passIcon,
      inputValue: null
    };
  },
  methods: {},
  mounted() {
  }
};
</script>

<style scoped lang="scss">
.input {
  width: 100%;
  position: relative;

  &__label {
    visibility: hidden;
  }
  &__input {
    width: 100%;
    height: 2.875rem;
    border: none;
    border-radius: 5px;
    background-color: #d0d0e0;
    margin-bottom: 0.875rem;
    padding-left: 17%;
    font-family: "Poppins", sans-serif;
    color: #2c253f;
    box-sizing: border-box;
  }
  &__icon {
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
    top: calc(50% - 1.1rem);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    left: 0.4rem;

  }

}
</style>
